import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';

export const StyledBarBackground = styled.div`
    background-color: ${(props) => props.theme.shades.lightGrey};
    height: 8px;
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
`;

export const StyledBarForeground = styled(({ width, ...rest }: { width: number }) => (
    <div {...rest} />
))`
    background-color: ${(props) => props.theme.colors.main4};
    height: 8px;
    width: ${(props: { width: number }) => props.width}%;
    border-radius: 5px;
`;

export const StyledBarDescriptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 2px;
    padding-bottom: 10px;
`;

export const StyledBarDescription = styled(({ color, ...rest }: { color: string }) => (
    <span {...rest} />
))`
    font-size: ${(props) => props.theme.fontSize.copyTextS};
    font-weight: 700;
    display: block;
    color: ${(props: { color: string }) => (props.color ? props.color : '')};

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextL};
    }
`;

export const StyledBarValue = styled(({ hasBaseValue, ...rest }: { hasBaseValue: boolean }) => (
    <div {...rest} />
))`
    font-size: ${(props) => props.theme.fontSize.copyTextS};
    justify-self: flex-end;
    min-width: ${(props: { hasBaseValue: boolean }) => (props.hasBaseValue ? '60px' : 'initial')};
    text-align: right;

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextL};
        min-width: initial;
        text-align: initial;
    }
`;

export const StyledValue = styled.span`
    font-weight: 700;
`;
